import {observer} from 'mobx-react-lite'
import React, {useCallback, useRef} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {IconTabler} from '@components/common/icon-tabler/icon-tabler'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {useStore} from '@components/subtasks-old/subtasks-store'
import {TextArea} from '@components/textarea'
import {keyboardHandler, noPropagate, useClickAway} from '@containers/hooks'

const TwTextArea = tw(TextArea)`
  !border-none
  !outline-none
  !shadow-none
  !bg-transparent
  !w-full
  p-0
  m-0
  leading-4
  text-14
  text-primary
  placeholder:text-placeholder
`

const TwTextareaScrollContainer = tw(WithPerfectScrollbar)`
  flex-1
  pr-8
  -mr-8
`

const TwNewTaskEditorInput = tw.div`
  relative
  flex
  flex-col
  h-full
  w-full
  rounded-8
  bg-background-card
  shadow-xs
  p-8
  pl-28
  min-h-64
  max-h-200
`

export const NewTaskEditorInput = observer(
  (props: {stayOpen: boolean; onEndAdd?: () => void}) => {
    const [state, store] = useStore()
    const ref = useRef<HTMLInputElement | null>(null)

    const onClickOutside = useCallback(() => {
      if (store.state.newTaskTitle.length) {
        store.createNewTask()
      }
      store.setShowNewTaskInput(false)
      props?.onEndAdd?.()
    }, [store, props.onEndAdd])

    useClickAway(ref, onClickOutside)

    return (
      <TwNewTaskEditorInput>
        <IconTabler
          icon="IconCustomTaskDoneEmpty"
          className="absolute top-8 left-8 text-icon-placeholder"
        />
        <TwTextareaScrollContainer>
          <TwTextArea
            ref={ref}
            autoFocus
            onKeyDown={keyboardHandler({
              enter: () => {
                store.createNewTask()
                !props.stayOpen && store.setShowNewTaskInput(false)
                //https://bugs.chromium.org/p/chromium/issues/detail?id=32865
                setTimeout(() => {
                  store.setNewTaskTitle('')
                }, 0)
                return true
              },
              escape: () => {
                store.setNewTaskTitle('')
                store.setShowNewTaskInput(false)
                props?.onEndAdd?.()
                return true
              }
            })}
            onBlur={onClickOutside}
            onMouseDown={noPropagate}
            value={state.newTaskTitle}
            onChange={e => store.setNewTaskTitle(e.target.value)}
            placeholder={Lang.msg.subtask.enterTitle}
          />
        </TwTextareaScrollContainer>
      </TwNewTaskEditorInput>
    )
  }
)
